<p>cgrp-off-option-dialog works!</p>
